































import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { ChainMap } from '@/known_blockchains'
import TxFilter from '@/components/Transaction/TxFilter.vue'

@Component({ components: { TxFilter } })
export default class TxFilterDialog extends Vue {
    @Prop() chains!: ChainMap[]
    dialog = false
    notifications = false
    sound = true
    widgets = false
    items: any[] = []
    selection: any[] = []

    created() {
        this.items = this.chains.map((chain: ChainMap) => ({
            id: chain.id,
            name: `${chain.name} (${chain.fullname})`,
            children: chain.txTypes.map((type) => ({
                id: type[0],
                name: type[1].long,
            })),
        }))

        this.selection = this.items.flatMap((item) => item.children)

        this.$emit(
            'change',
            this.selection.map((val) => val.id)
        )
    }

    // simply passes value through to the data request layer above
    setFilter(val: string[]) {
        this.$emit('change', val)
        this.dialog = false
    }
}
